module.exports = __webpack_public_path__ + "img/bg_yinhang@3x.c8ce9447.png";